/** Namespace `customers` — PLAT-2026-114 (quản trị khách theo app), bản gốc tiếng Việt. */
export const customers = {
  workspacesTitle: "Không gian khách hàng của {app}",
  workspacesSubtitle:
    "Đọc trực tiếp từ {app} mỗi lần mở — hub không lưu bản sao. Gói hiển thị là gói ĐANG CÓ HIỆU LỰC (đã tính hạn), không phải giá trị thô trong bảng.",
  usersTitle: "Người dùng của {app}",
  usersSubtitle: "Đọc trực tiếp từ {app} mỗi lần mở — hub không lưu bản sao.",
  searchWorkspaces: "Tìm theo tên, slug, mã số thuế hoặc email chủ",
  searchUsers: "Tìm theo email hoặc tên",
  search: "Tìm",
  loadMore: "Xem thêm",
  loadFailed: "Không đọc được dữ liệu từ app.",
  empty: "Không có kết quả.",
  notSupported: "App này chưa hỗ trợ quản trị khách.",
  notConfigured: "Hub chưa được cấu hình để gọi {app} (thiếu URL hoặc secret đọc).",

  colName: "Tên",
  colOwner: "Chủ",
  colPlan: "Gói",
  colBranches: "Chi nhánh",
  colMembers: "Thành viên",
  colCreated: "Ngày tạo",
  colLastActive: "Hoạt động gần nhất",
  colEmail: "Email",
  colWorkspaces: "Không gian khách hàng",
  colRole: "Vai",
  colJoined: "Tham gia",
  colStatus: "Trạng thái",
  never: "chưa có",
  verified: "đã xác thực",
  unverified: "chưa xác thực",

  status_active: "đang dùng",
  status_trialing: "dùng thử",
  status_grace: "ân hạn",
  status_expired: "hết hạn",
  status_cancelled: "đã huỷ",
  status_continuity: "duy trì",
  status_none: "chưa đăng ký",
  status_past_due: "quá hạn thanh toán",
  status_canceled: "đã huỷ",
  until: "đến {at}",
  managedByHub: "do hub cấp",

  back: "← Danh sách khách hàng",
  detailTitle: "Không gian khách hàng « {name} »",
  sectionPlan: "Gói",
  sectionMembers: "Thành viên",
  sectionHistory: "Lịch sử gói",
  storedVsEffective: "Trong bảng: {plan} · {status}",
  noHistory: "Chưa có lần đổi gói nào.",
  eventBy: "bởi {by}",
  eventReason: "Lý do: {reason}",

  changePlan: "Đổi gói…",
  planChangeNotConfigured: "Chưa đổi gói được: hub thiếu secret đổi gói cho app này (`HQ_<APP>_PLAN_SECRET`).",
  planChangeNoPermission: "Đổi gói cần vai Chủ.",
  dialogTitle: "Đổi gói thủ công",
  action: "Hành động",
  action_trial: "Cho dùng thử",
  action_grant: "Cấp gói (không thu tiền)",
  action_revoke: "Thu hồi về gói miễn phí",
  actionHint_trial: "Tối đa 90 ngày. Hết hạn là về gói miễn phí ngay, không ân hạn.",
  actionHint_grant: "Tối đa 12 tháng. Cho đối tác / khách đặc biệt. Hết hạn là về gói miễn phí ngay.",
  actionHint_revoke: "Thu hồi gói dùng thử / gói cấp tay. Gói đang có lượt thu tiền thì app từ chối.",
  plan: "Gói",
  endsAt: "Ngày kết thúc",
  reason: "Lý do (ít nhất 10 ký tự)",
  preview: "Trước → sau: {before} → {after}",
  confirm: "Xác nhận đổi gói",
  confirmAgain: "Bấm lần nữa để xác nhận",
  cancel: "Huỷ",
  saving: "Đang đổi…",
  saved: "Đã đổi gói. Khách có thể cần tải lại trang để thấy nhãn gói mới.",
  replayed: "Lượt này đã được ghi trước đó — kết quả không đổi.",
  saveFailed: "Không đổi được gói.",
} as const;
